import React, { useMemo, useRef } from 'react';

import { DayProps } from 'components/pages/Epg/interface';

import DayHooksCombiner from './components/DayHooksCombiner/DayHooksCombiner';

import styles from './Day.module.scss';

interface Props {
  day: DayProps;
  primeTime: number;
}

interface RefProps extends HTMLButtonElement {
  callBack: (value: DayProps) => void;
}

const Day = ({ day, primeTime }: Props) => {
  const ref = useRef<RefProps | null>(null);

  function clickHandle(props: DayProps) {
    if (ref.current?.callBack) {
      ref.current.callBack(props);
    }
  }

  const item = useMemo(() => {
    return (
      <button
        ref={ref}
        key={day.title}
        data-target={day.delta}
        className={styles.day}
        aria-label={day.fullDayName}
        tabIndex={0}
        onClick={clickHandle.bind(null, day)}
        type='button'
      >
        <span aria-hidden>{day.title}</span>
      </button>
    );
  }, [day.day, day.delta, day.title]);

  return (
    <>
      {item}
      <DayHooksCombiner forwardRef={ref} day={day} primeTime={primeTime} />
    </>
  );
};

export default Day;
